<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnSaveExcel'   //Save Excel
                    ]"
                    @btnRetrieve="btnRetrieve()"
                    @btnSaveExcel="btnSaveExcel()"
                  >
                    <template v-slot:body>
                      <v-layout column>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <v-icon small color="blue">mdi-circle</v-icon>
                          <span class="pa-1 subTitle">Ship No : </span>
                          <v-col cols="2">
                            <v-select
                                v-model="selectShipNo"                            
                                :items="shipNoList"
                                item-value="shipNo"
                                item-text="shipNo"
                                return-object
                                single-line
                                outlined
                                dense
                                @change="changeShipNo"
                                 />                            
                          </v-col>
                          <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> Por No: </span>
                          <v-col cols="2">
                            <v-select
                                v-model="selectPorNo"
                                :items="porList"
                                item-value="porNo"
                                item-text="porNo"
                                return-object
                                single-line
                                outlined
                                dense                                
                                />                                                      
                          </v-col>
                          <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> Block: </span>
                          <v-col cols="2">
                            <v-select
                               v-model="selectBlock"
                                :items="blockList"
                                item-value="block"
                                item-text="block"
                                return-object
                                single-line
                                outlined
                                dense />                                                      
                          </v-col>
                        </v-row>
                      </v-layout>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">                
                  <DxDataGrid id="epms9113" 
                    class="listBox" 
                    :ref="epms9113Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                  >
                    <DxEditing :use-icons="true" />
                    <DxColumn data-field="rnum" caption="No" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn caption="Ship No" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="shipNo" caption="Activity" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                   </DxColumn>
                    <DxColumn caption="Por No" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="porNo" caption="Piece No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption="Block" width="7%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="block" caption="Weight" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption="Insp." width="7%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="insp" caption="Quantity" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>  
                    <DxColumn caption="Process" width="7%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="proc" caption="Class" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption="Press" width="7%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="press" caption="Paint" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption="Material Specification" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="ser" caption="Ser" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="matlCd" caption="Material Code" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="matlUnit" caption="Unit" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="qty" caption="Qty" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="wgt" caption="M.Weight" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="length" caption="Lenght" width="7%" data-type="string" alignment="center" :allow-editing="false" />                    
                      <DxColumn data-field="cls" caption="M.Class" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "Weld Type" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="weldType" caption="Weld Point" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "Bend Radius" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="bendR" caption="Bend Qty" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "HVS Supply" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="outFitChk" caption="Maker Purchase" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxPaging :enabled="true" :page-size="20" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxButton , DxExport } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import { getDateFormat, getCurrentDate, getPreMonth , getFirstDay} from '@/utils/common.js'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { getShipNoList1, epms9000_block, epms9000_por_no } from '@/api/view/hip/common/common.js'
import { getemps9113, epms9113Xls} from '@/api/view/hip/91/epms9113.js'
import { getNumComma } from '@/utils/common.js'

export default {
  name: 'epms9113',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,    
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epms9113Ref: 'epms9113Ref',
      gridMainList: [],
      useBtnList: ['btnRetrieve' , 'btnSaveExcel'],
      selectShipNo: '',
			shipNoList: [],     
      selectPorNo: '',
      porList: [],     
      selectBlock: '',      
      blockList: [],     
      makerCd: this.$store.state.user.makerCd,
      

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms9113Ref)
    },
  },  
  methods: { 

    async getShipNoList() {
      const param = {
        makerCd: this.makerCd
      }

      await getShipNoList1(param).then(async res => {        

        this.shipNoList = res.list
        this.shipNoList.unshift({
          shipNo: ''
        })
        this.selectShipNo = this.shipNoList[0]

        await this.getBlockList()
        await this.getPorNoList()
      })
    },
    
    async getPorNoList() {
          this.openLoading()

          const param = {
            incNotPo: 'Y',
            shipNo: this.selectShipNo.shipNo,
            makerCd: this.makerCd
          }

          await epms9000_por_no(param).then(res => {            

            this.porList = res.list
            this.porList.unshift({
              porNo: ''
            })
            this.selectPorNo = this.porList[0]
          }).finally(() => {
            this.endLoading()
          })
    },
    
    async getBlockList() {
      this.openLoading()

      const param = {
        incNotPo: 'Y',
        shipNo: this.selectShipNo.shipNo,
        makerCd: this.makerCd
      }

      await epms9000_block(param).then(res => {
        // console.log('epms9000_blockRes', res)

        this.blockList = res.list
        this.blockList.unshift({
          block: ''
        })
        this.selectBlock = this.blockList[0]
      }).finally(() => {
        this.endLoading()
      })
    },

    changeShipNo(e){
      this.selectBlock = null
      this.blockList = []
      this.selectPorNo = null
      this.porNoList = []

      this.getBlockList()
      this.getPorNoList()

    },
    init(){				
				this.getShipNoList()
			},

    btnRetrieve(){      
      if(this.selectShipNo === null) {
        this.vToastify(this.$t('Please select Ship No'), 'warn')
        return
      }
      if(this.selectPorNo === null){
        this.selectPorNo = ''
      }
      if(this.selectBlock === null){
        this.selectBlock = ''
      }
      this.doSearchMain()
    },

    async doSearchMain(){
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        shipNo: this.selectShipNo.shipNo,
        porNo: this.selectPorNo.porNo,
        block: this.selectBlock.block
      }
      // console.log(params)
      
      await getemps9113(params).then(res => {       
        // this.gridMainList = res.list       

          let list = []
          let cnt = 1;
        
          res.list.forEach(e => {
           
            list.push(
              {
                id: cnt++ , rnum: e.rnum, shipNo: e.shipNo, porNo: e.porNo, block: e.block, insp: e.insp, proc: e.proc, press: e.press, 
                ser: e.matlSpec, matlCd: e.matlSpec, matlUnit: e.matlSpec, qty: e.matlSpec, wgt: e.matlSpec,  length: e.matlSpec,  cls: e.matlSpec,   
                weldType: e.weldType, bendR: e.bendR, outFitChk: e.outFitChk
              },
              {
                id: cnt++ , rnum: e.rum, shipNo: e.act,  porNo: e.partNo,  block: e.wgt, insp: e.pcqty, proc: e.cls, press: e.paint,                    
                ser: e.ser, matlCd: e.matlCd, matlUnit: e.unit, qty: e.qty, wgt: e.fittWgt,  length: e.lengths,  cls: e.clsChk,                            
                weldType: e.weldPoint, bendR: e.bendQty, outFitChk: e.dogupChk  
              }
            )
          });
          this.gridMainList = list


      }).finally(() => {
        this.endLoading()
      })

    },

    btnSaveExcel(){            
      this.openLoading('Excel Saving')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        shipNo: this.selectShipNo.shipNo,
        porNo: this.selectPorNo.porNo,
        block: this.selectBlock.block
      }
      epms9113Xls(params)
      this.endLoading()
    },


    cellPrepared(e) {
      if(e.rowType === 'header') {
        if(e.column.caption.indexOf('Material Specification') > -1) {
          if(e.column.caption === 'Material Specification') {
            e.cellElement.setAttribute('colspan', 7)
          } else {
            e.cellElement.style.display = 'none'
          }
        }
      }      
      else if(e.rowType === 'data') {
        
        if(Number(e.rowIndex) % 2 == 0 && e.column.caption === 'No'){
            e.cellElement.setAttribute('rowspan', 2)
          }else if(Number(e.rowIndex) % 2 != 0 && e.column.caption === 'No'){
            e.cellElement.style.display = 'none'
          }
          else if(Number(e.rowIndex) % 2 == 0  )
            {
              if (e.column.caption === 'Ser'){                               
                  e.cellElement.setAttribute('colspan', 7)
               }  
               else if ((e.column.name === 'matlCd') || (e.column.name === 'matlUnit') || (e.column.name === 'qty')
                  || (e.column.name === 'wgt') || (e.column.name === 'length') || (e.column.name === 'cls')) {
                
                      e.cellElement.style.display = 'none'
             
                }

              }  
            }
        } 
        
    },
   
    async mounted() {        
      await this.init()      
    }
  }

</script>
<style lang="scss" scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }
  .vat {
    color: blue;
  }
  .receiptBtn {
    font-weight: bold;
  }
  .receiptBtn:hover {
    color: #4980BC;
  }
  .v-btn {
    text-transform: unset !important;
    // height: 16px !important;
  }
</style>